import React from 'react';

import { Row, Col, Card, Space, Tag, Typography } from 'antd';

import { CrossedContainer } from '../../boxes/components/lifecycle/CrossedContainer';
import CopyToClipboard from '@/components/CopyToClipboard';
import DownArrowIcon from '@/components/icons/DownArrowIcon';
import { StatusDeletedHeader } from '@/features/boxes/components/lifecycle/StatusDeletedHeader';
import { formatISODate } from '@/helpers/dates';

export const TimeLineAltCard = ({
  timeLineEvent,
  isDeletable,
  isDeleted,
  showModal,
}) => (
  <Space
    direction="vertical"
    style={{ width: '100%', paddingTop: '3rem' }}
    size={0}
  >
    {/* Header row (date + source) */}
    <Row>
      {isDeleted && <StatusDeletedHeader timeLineEvent={timeLineEvent} />}
    </Row>
    <Row>
      <Col style={{ paddingBottom: '1rem', width: 105 }}>
        <Tag
          bordered={false}
          style={{ fontWeight: 'bold', opacity: isDeleted ? 0.3 : 1 }}
        >
          {formatISODate(timeLineEvent.created_at, 'dd/MM/yyyy - HH:mm:ss')}
        </Tag>
      </Col>
      <Col flex="auto" />
      <Col span={8}>
        <Typography.Text
          style={{
            color: '#808080',
            display: 'flex',
            justifyContent: 'end',
            marginRight: 25,
          }}
        >
          {timeLineEvent.source_type === 'physical_station'
            ? `${timeLineEvent.source_name} / ${timeLineEvent.station_source}`
            : timeLineEvent.station_source}
        </Typography.Text>
      </Col>
    </Row>
    {/* Card row (icon + card content + delete) */}
    <Row align="middle" wrap={false} style={{ width: '100%' }}>
      <Col
        style={{
          marginRight: 5,
          display: 'flex',
          alignItems: 'center',
          opacity: isDeleted ? 0.3 : 1,
        }}
      >
        <DownArrowIcon />
      </Col>
      <Col flex={1} style={{ minWidth: 0, opacity: isDeleted ? 0.3 : 1 }}>
        <CrossedContainer isDeleted={isDeleted}>
          <Card
            style={{
              width: '100%',
              marginRight: '1.5625rem',
              boxShadow: '0 .25rem .25rem 0 rgba(0, 0, 0, 0.25)',
              border: '1px solid #008379',
              borderRadius: 10,
            }}
            bodyStyle={{ padding: '1rem' }}
          >
            <Row align="middle" wrap={false} style={{ width: '100%' }}>
              <Col
                flex={1}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Typography.Title
                  level={2}
                  style={{
                    fontSize: 20,
                    display: 'flex',
                    alignItems: 'end',
                    height: '100%',
                    margin: 0,
                  }}
                  data-testId="subStatus-title"
                >
                  {timeLineEvent.sub_status}
                </Typography.Title>
                <Space
                  direction="vertical"
                  size={0}
                  style={{ paddingBottom: 10 }}
                >
                  <Typography.Text>
                    {' '}
                    by <b>{timeLineEvent.created_by.email}</b>{' '}
                  </Typography.Text>
                  <Space align="center" size={8}>
                    <Typography.Text>
                      {timeLineEvent.created_by.id}
                    </Typography.Text>
                    <Space style={{ cursor: 'pointer', marginTop: '8px' }}>
                      <CopyToClipboard
                        round
                        data={timeLineEvent.created_by.id}
                      />
                    </Space>
                  </Space>
                  {timeLineEvent.sub_status === 'FLAGGED' && (
                    <>
                      <Typography.Text data-testId="subStatus-reason">
                        <strong>Reason:</strong> {timeLineEvent.reason || 'N/A'}
                      </Typography.Text>
                      <Typography.Text data-testId="subStatus-details">
                        <strong>Notes:</strong> {timeLineEvent.details || 'N/A'}
                      </Typography.Text>
                    </>
                  )}
                </Space>
              </Col>
              {isDeletable && (
                <Col
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: 80,
                  }}
                >
                  <Typography.Text
                    style={{
                      fontWeight: 700,
                      color: isDeleted ? 'black' : '#38a169',
                      cursor: isDeleted ? 'default' : 'pointer',
                    }}
                    onClick={isDeletable && !isDeleted ? showModal : null}
                  >
                    Cancel
                  </Typography.Text>
                </Col>
              )}
            </Row>
          </Card>
        </CrossedContainer>
      </Col>
    </Row>
  </Space>
);
